<template>
  <div class="home">
    <table id="login">
      <tr>
        <th colspan="2">로그인</th>
        <th colspan="2">회원가입</th>
      </tr>
      <tr>
        <td>ID</td>
        <td><input type="text" v-model="LoginID" tabindex="2"></td>
        <td>ID</td>
        <td><input type="text" v-model="CreateID" tabindex="7"></td>
      </tr>
      <tr>
        <td>PW</td>
        <td><input type="password" v-model="LoginPW" tabindex="3" @keyup.enter="login()"></td>
        <td>PW</td>
        <td><input type="password" v-model="CreatePW" tabindex="8"></td>
      </tr>
      <tr>
        <td colspan="2" rowspan="2"><button @click="login()" tabindex="4">로그인</button> <button @click="requestSearchEmailForId()" tabindex="6">계정 찾기</button></td>
        <td>Email</td>
        <td><input type="email" v-model="CreateEmail" tabindex="9" @keyup.enter="create()"></td>
      </tr>
      <tr>
        <td colspan="2"><button @click="create()" tabindex="10">회원가입</button></td>
      </tr>
    </table>
  </div>
</template>

/** tabindex:탭키로 이동할때 순서(2부터 시작하면 된다.) */

<script>
import { getCurrentInstance } from '@vue/runtime-core';

export default {
  data() {
    return {
      app:"",
      socket:"",
      LoginID:"",
      CreateID:"",
      LoginPW:"",
      CreatePW:"",
      CreateEmail:"",
    }
  },
  created() {
    this.app = getCurrentInstance();
    this.socket = this.app.appContext.config.globalProperties.$socket;
  },
  methods: {
    login() {
      console.log("로그인 요청");
      if(this.LoginID.trim() == "") {
        console.log("로그인 ID 빈칸 오류");
        alert('ID를 입력해주세요.');
        return;
      }
      if(this.LoginPW.trim() == "") {
        console.log("로그인 PW 빈칸 오류");
        alert('비밀번호를 입력해주세요.');
        return;
      }
      this.socket.send('{event:"loginRequest", ID:' + this.LoginID + ', PW:' + this.LoginPW + '}');
    },
    create() {
      console.log("회원가입 요청");
      if(this.CreateID.trim() == "") {
        console.log("회원가입 ID 빈칸 오류");
        alert('ID를 입력해주세요.');
        return;
      }
      if(this.CreatePW.trim() == "") {
        console.log("회원가입 PW 빈칸 오류");
        alert('PW를 입력해주세요.');
        return;
      }
      if(this.CreateEmail.trim() == "") {
        console.log("회원가입 Email 빈칸 오류");
        alert('Email을 입력해주세요.');
        return;
      }
      this.socket.send('{event:"createUserRequest", ID:' + this.CreateID + ', PW:' + this.CreatePW + ', Email:' + this.CreateEmail + '}');
    },
    requestSearchEmailForId() {
      let request = prompt("가입시 사용한 이메일을 입력해주세요.");
      if(request == null) return;
      if(request.trim() == "") return;
      this.socket.send('{event:"requestSearchEmailForId", Email:' + request + '}');
    },
  }
}
</script>

<style>
  
</style>